<template>
  <el-row :style="rowStyle">
    <el-col :span="6" class="__col-h100">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">
          <span style="display: inline-block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: calc(100% - 90px);" :title="$lang(flowName)" v-html="$lang(flowName)"></span>
          <span class="pull-right" style="padding-right:5px;width: 90px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">({{$lang("双击移入")}}>>)</span>
        </div>
        <div class="__panel-body">
          <mw-li-tree :autoLoad="true" :async="false" :multiple="false"
                      :ref="'candidate'+flowId" :treeData="candidates" @dblClick="dblClick"  @beforeDataFilter="candidateDataHandle"></mw-li-tree>
        </div>
      </div>
    </el-col>
    <el-col :span="5" class="__col-h100" style="padding-left:5px;">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">{{$lang("已选")}}<span class="pull-right" style="padding-right:5px;width: calc(100% - 60px); text-align: right; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">({{$lang("双击移出")}})</span></div>
        <div class="__panel-body">
          <mw-li-tree :autoLoad="true" :async="false" :multiple="true"
                      :ref="'planned'+flowId" :treeData="planneds" @dblClick="dblClickSelected"></mw-li-tree>
        </div>
      </div>
    </el-col>
    <el-col :span="2" class="__col-h100">
      <div class="__sel">
        <el-button type="primary" class="__btn" :leading="sendBtnLeading" @click="sendClick()" style="padding-bottom:5px;">{{$lang("发送")}}>></el-button>
        <br/><br/>
        <el-button class="__btn" :leading="takenBtnLeading" @click="takenClick()" style="padding-top:5px;">{{$lang("取回")}}</el-button>
      </div>
    </el-col>
    <el-col :span="5" class="__col-h100">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">{{$lang("在办")}}</div>
        <div class="__panel-body">
          <mw-li-tree :autoLoad="true" :async="false" :multiple="true"
                      :ref="'doing'+flowId" :treeData="doings" :isDblClickDeleteNode="false"></mw-li-tree>
        </div>
      </div>
    </el-col>
    <el-col :span="5" class="__col-h100" style="padding-left:5px;">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">{{$lang("办毕")}}</div>
        <div class="__panel-body">
          <li class="__item" v-for="n in finisheds" v-html="n.name"></li>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import MwLiTree from "../tree/li.vue";

  export default {
    name: 'MwWtLi',
    components: {
      MwLiTree
    },
    props: {
      params: {
        type: Object
      },
      rowStyle:{
        type:String,
        default:function(){
          return 'height:225px; padding-top:5px;';
        }
      },
      flowId:{
        type: String
      },
      flowName:{
        type: String
      },
      flowType:{
        type:String
      },
      options:{
        type: Object
      },
      activityId:{
        type: String
      },
      candidates:{
        type:Array,
        default:function(){
          return [];
        }
      },
      planneds:{
        type:Array,
        default:function(){
          return [];
        }
      },
      doings:{
        type:Array,
        default:function(){
          return [];
        }
      },
      finisheds:{
        type:Array,
        default:function(){
          return [];
        }
      }
    },
    data() {
      let me = this;
      return {
        sendBtnLeading:false,
        takenBtnLeading:false
      }
    },
    methods: {
      btnDebounce:_.debounce(function(callback){
        let me=this;
        if(callback){
          callback();
        }
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      candidateDataHandle(data){
        data.forEach(d=>{
          if(!d.text) {
            if (d.name) {
              d.text = d.name;
              if (window.$currentBrowserLanguage==='en') d.text = d.Englishname || d.name;
            }
          }
          if(!d.originalId){
            d.originalId=d.id; //原ID赋值给originalId
            if(d.departmentId){
              d.id = d.departmentId+'_'+d.id;
            }
          }
        });
      },
      dblClick(data){ //移入已选
        var me = this;
        //移出可选框
        var fcandidate = me.candidates;
        var idx;
        fcandidate.map((v, d) => {
          if (v.id == data.originalId) {
            idx = d;
            return;
          }
        });
        if(idx){
            me.candidates.splice(idx, 1);
        }
        //移入已选框
        var node = Object.assign({}, data);
        node.id = node.originalId;   //还原为用户或部门ID
        delete node.originalId;
        var text = data.name;
        if (window.$currentBrowserLanguage === 'en') text = data.Englishname || data.name;
        node.text = text;
        node.flowId = me.flowId;
        me.planneds.push(node);
        me.mwRef('planned' + me.flowId).refreshData(me.planneds);
      },
      dblClickSelected(data){ //移入到可选
        var me = this;
        //移出已选框
        var fplanned = me.planneds;
        let idx;
        fplanned.map((v, d) => {
          if (v.id == data.id) {
            idx = d;
            return;
          }
        });
        if(idx!==undefined){
            me.planneds.splice(idx, 1);
        }

        //移入可选框
        var node = Object.assign({}, data);
        if(!data.originalId){
          node.originalId=data.id; //原ID赋值给originalId
          if(data.departmentId){
            node.id = data.departmentId+'_'+data.id;
          }
        }
        var text = data.name;
        if (window.$currentBrowserLanguage === 'en') text = data.Englishname || data.name;
        node.text = text;
        node.flowId = me.flowId;
        var cidx = node.idx;
        if (cidx || cidx == 0) {
          me.candidates.splice(cidx, 1, node);
        } else {
          me.candidates.push(node);
        }
        me.mwRef('candidate' + me.flowId).refreshData(me.candidates);
      },
      sendClick(){ //选中已选发送
        var me = this;
        me.btnDebounce(function(){
          me.sendBtnLeading=true;
          var data = me.mwRef('planned' + me.flowId).getSelectNodes();
          if (data.length < 1) {
            me.sendBtnLeading=false;
            return;
          }
          var activities = [];
          var items = [];
          data.map((v) => {
            items.push(me._nodeAsItem(v));
          });
          var activity = {};
          activity.items = items;
          activity.flowId = me.flowId;
          activity.activityId = me.activityId;
          activity.type = me.flowType;
          activity.options = me.options;
          activities.push(activity);
          var params = {};
          params.type = "complete";
          params.actionDescription = "发送";
          params.taskId = me.params.taskId;
          params.appId = me.params.appId;
          params.formId = me.params.formId;params.formKey = me.params.formKey;
          params.activities = activities;
          me.params.isOperation = true;
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          me.mwApi.process.batchCommit(params).then((res) => {
            var rr = res.result;
            if (rr && typeof res.success != 'undefined' && !rr.success) {
              me.mwMsg('info', '发送失败!');
              me.sendBtnLeading=false;
              return;
            } else if (res.success) {
              data.map((v) => {
                //移入在办框
                me.doings.push(v);
                //移出已选框
                var fplanned = me.planneds;
                var idx;
                fplanned.map((fv, d) => {
                  if (fv.id == v.id) {
                    idx = d;
                    return;
                  }
                });
                if(idx!==undefined){
                    me.planneds.splice(idx, 1);
                }
                //移出办毕框
                var fidx;
                me.finisheds.map((fv, d)=>{
                  if(fv.id==v.id){
                    fidx=d;
                    return;
                  }
                });
                if(fidx!==undefined){
                    me.finisheds.splice(fidx, 1);
                }
              });

              //刷新已选框、在办框
              me.mwRef('planned' + me.flowId).refreshData(me.planneds);
              me.mwRef('doing' + me.flowId).refreshData(me.doings);
              me.sendBtnLeading=false;
            }
          }).catch(()=>{
            me.sendBtnLeading=false;
          })
        });
      },
      takenClick(){//选中在办取回
        var me = this;
        me.btnDebounce(function(){
          me.takenBtnLeading=true;
          var data = me.mwRef('doing' + me.flowId).getSelectNodes();
          if (data.length < 1) {
            me.takenBtnLeading=false;
            return;
          }
          var masterObjectIds = [];
          data.map((v) => {
            masterObjectIds.push(v.id);
          });
          var params = {};
          params.taskId = me.params.taskId;
          params.flowId = me.flowId;
          params.masterObjectIds = masterObjectIds;
          me.params.isOperation = true;
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          if(window.$Env && $Env.yzTakenFilterSecondSend){
            params.filterSecondSend = true;
          }
          me.mwApi.process.batchTakenSubProcess(params).then((res) => {
            if (res.success) {
              var sent = res.result && res.result.sent && res.result.sent.length ? res.result.sent : [];
              if(sent.length > 0){
                PF.message("["+sent.join(",")+"]已办理，不能取回");
              }
              data.map((v) => {
                //移入已选框
                if(sent.indexOf(v.name)==-1){
                  me.planneds.push(v);
                  //移出在办框
                  var idx;
                  me.doings.map((fv, d) => {
                    if (fv.id == v.id) {
                      idx = d;
                      return;
                    }
                  });
                  if(idx!==undefined){
                      me.doings.splice(idx, 1);
                  }
                }
              });
              //刷新在办框、已选框
              me.mwRef('planned' + me.flowId).refreshData(me.planneds);
              me.mwRef('doing' + me.flowId).refreshData(me.doings);
            }
            me.takenBtnLeading=false;
          }).catch(()=>{
            me.takenBtnLeading=false;
          });
        });
      },
      getPlannedsData(){ //保存已选
        var me = this;
        var items=[];
        me.planneds.map((plan) => {
          items.push(me._nodeAsItem(plan));
        });
        return items;
      },
      _nodeAsItem(n){
        var item = {};
        if (n.type == 'U') {
          item.group = n.departmentId;
          if (!item.users) {
            item.users = [];
          }
          item.users.push({id: n.id});
        } else if (n.identities) {
          item.group = n.id;
          n.identities.map(i => {
            if (i.type == 'U') {
              if (!item.users) {
                item.users = [];
              }
              item.users.push({id: i.id});
            } else {
              if (!item.identities) {
                item.identities = [];
              }
              item.identities.push({id: i.id});
            }
          });
        }
        return item;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/worktrack/liwt.vue